import Notifications from "@/Component/Notifications"

const NotificationsPage = () => {
  return (
    <Notifications />
  )
}

export default NotificationsPage
